<template lang="pug">
  a.d-block.HelpAlert.clean(target="_blank" href="https://www.ipratico.com/suite/ipratico-contatti.php")
    v-alert.white.elevation-2.ma-0(type="info" outlined) Hai bisogno di aiuto?&nbsp;
        span.fake-link Contattaci ora!
</template>

<script>
export default {
  name: "HelpAlert"
};
</script>
